var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPainting = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Color-Brush-2--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Color Brush 2 Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M23.06 0.87a3.07 3.07 0 0 0 -4.56 0.35l-9.93 13a0.25 0.25 0 0 0 0.09 0.37 5.08 5.08 0 0 1 2.4 2.46 0.26 0.26 0 0 0 0.41 0.07L23.1 5.26a3.08 3.08 0 0 0 -0.04 -4.39Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.88 15.88a3.66 3.66 0 0 0 -4.83 1.83c-0.19 0.43 -0.33 0.83 -0.47 1.2C2.19 20 2 20.53 1 20.79a1.34 1.34 0 0 0 -0.22 2.51 7.47 7.47 0 0 0 3.14 0.7 7 7 0 0 0 2.47 -0.45 6 6 0 0 0 3.32 -2.85 3.65 3.65 0 0 0 -1.83 -4.82Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPainting);
export default ForwardRef;